import { Component, AfterViewInit, OnInit,ChangeDetectorRef } from "@angular/core";
import { ROUTES } from "./menu-items";
import { RouteInfo } from "./sidebar.metadata";
import { Router,ActivatedRoute,Params,NavigationEnd } from "@angular/router";
import { takeWhile,filter,map,mergeMap } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
declare var $: any;
import { FvmsApiAuthService } from "src/app/shared/service";
import { FvmsUserInfo } from "src/app/shared/vo/fvms.user.info";
import * as _ from "lodash";

@Component({
    selector: "app-sidebar"
    ,templateUrl: "./sidebar.component.html"
})
export class SidebarComponent implements OnInit {
    showMenu = "";
    showSubMenu = "";
    public sidebarnavItems: any[];
    isContinue:boolean = true;
    currentUserInfo:FvmsUserInfo;
    ipAccessDevice:string;
    pMenuId:string;
    userGroupId:number;
    // 1 : 관리자
    // 100 : 관리자(업체)   // 서울우유 대표 계정 (모든 권한)
    // 200 : 운영자(업체)   // 서울우유 운영 계정 (차량,단말,계정,그룹 관리)
    // 300 : 운영자(그룹)   // 서울우유 하위그룹의 운영 계정 (??)
    // 1000 : 운전자        // 서울우유 운전자 계정
    // 99999 : 일반사용자   // 미정
    // if(limitLevel > userGroupId) ==> show menu

    constructor(
        private modalService: NgbModal
        ,private router: Router
        ,private activatedRoute: ActivatedRoute
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private changeDetectorRef: ChangeDetectorRef
    ) {
        this.router.events
            .pipe(takeWhile(() => this.isContinue))
            .pipe(filter(event => event instanceof NavigationEnd))
            .pipe(map(() => this.activatedRoute))
            .pipe(
                map(route => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                })
            )
            .pipe(filter(route => route.outlet === 'primary'))
            .pipe(mergeMap(route => route.data))
            .subscribe(event => {
                this.pMenuId = event['menuId'];
                this.changeDetectorRef.detectChanges();
            });
        
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
    }

    // End open close
    ngOnInit() {
        let sidebarnavItem = this.findRouteItem(this.router.url,ROUTES);
        if(sidebarnavItem) {
            this.pMenuId = sidebarnavItem.pMenuId;
            this.sidebarnavItems = ROUTES;
        }
        // this.sidebarnavItems = ROUTES.filter(sidebarnavItem => {
        //     return sidebarnavItem.limitLevel >= this.userGroupId;
        // });
        // this.fvmsApiAuthService.getCurrentUserInfo()
        //   .pipe(takeWhile(() => this.isContinue))
        //   .subscribe(currentUserInfo => {
        //     this.currentUserInfo = currentUserInfo;
        //   });

        // this.fvmsApiAuthService.getIpAccessDevice()
        //   .pipe(takeWhile(() => this.isContinue))
        //   .subscribe(response => {
        //       if(response && response.ip){
        //           this.ipAccessDevice = response.ip;
        //       }
        //   });
        
        // this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
    }

    deleteRouteItems(array, ids) {
        let i = array.length;
        while (i--) {
            if (ids.indexOf(array[i].id) !== -1) {
                array.splice(i, 1);
                continue;
            }
            array[i].submenu && this.deleteRouteItems(array[i].submenu, ids);
        }
        return array;
    }

    findRouteItem(searchUrl:string,listItem:any[]){
        let tmpArrUrl = searchUrl.split("?");
        let tmpSearchUrl = tmpArrUrl[0];
        let foundRouteItem = null;
        if(listItem){
            for(let a=0;a<listItem.length;a++){
                let routeItem = listItem[a];
                if(routeItem.path === tmpSearchUrl) {
                    foundRouteItem = routeItem;
                    break;
                }else if(tmpSearchUrl.indexOf(routeItem.path) > -1){
                    foundRouteItem = routeItem;
                    break;
                }else{
                    let foundChildItem = this.findRouteItem(tmpSearchUrl,routeItem.submenu);
                    if(foundChildItem){
                        foundRouteItem = routeItem;
                        break;
                    }
                }
            }
        }
        return foundRouteItem;
    }

    // this is for the open close
    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = "0";
        } else {
            this.showMenu = element;
        }
    }
    addActiveClass(element: any) {
        if (element === this.showSubMenu) {
            this.showSubMenu = "0";
        } else {
            this.showSubMenu = element;
        }
    }
}
